const messages = {
  title: "Prislistor och produktbroschyrer",
  description:
    "Ladda ner de senaste broschyrerna och flygbladen om våra Bridgestone- och Firestone-däck för personbilar, SUV och lätta transportbilar.",
  brochureCategories: {
    products: "Produkter",
    brand_and_solutions: "Varumärke och lösningar",
    season_and_promotions: "Säsong och kampanjer",
    format: "Format",
    cars_and_vans: "Personbil, SUV, lätt lastbil",
    summer: "Sommar",
    winter: "Vinter",
    promotions: "Kampanjer",
    all_season: "Året runt",
    truck_and_buses: "Lastbil och buss",
    motorcycle: "Motorcykel",
    agriculture: "Lantbruk",
    construction_machinery: "Entreprenadmaskiner",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Material",
    brochures: "Produktbroschyrer",
    price_list: "Prislistor",
    materials: "Material",
    video_in_store: "Video med undertexter",
    video_online: "Video utan undertexter",
    banner_website: "Banner",
    banner_social_media: "Sociala medier",
    logos: "Logotyper",
  },
  searchMedia: "Ange sökord",
  searchResults: "Sökresultat",
};

export default {
  messages,
};
